export default __webpack_public_path__ + "static/media/security-hero.a285106b.jpg";